export enum SelfRegistrationRoutePaths {
	Application = 'registratie',
	Result = 'resultaat'
}
